import { Typography } from '@mui/material';
import React, { FC } from 'react';
import { IWidgetProps } from 'types/analytics';
import { analyticsNumericFormat } from '../analytics/utils';

const WidgetNumeric: FC<IWidgetProps> = ({ items }) => {
	const res = (items || []).reduce((acc, item) => acc + item.count, 0);

	return (
		<Typography
			variant="h2"
			textAlign="center"
			title={intl.formatNumber(res)}
			pt={2}
		>
			{analyticsNumericFormat(res)}
		</Typography>
	);
};

export default WidgetNumeric;
